import { TranslationsContext } from '@teliaee/telia-translate';
import { addMinutes, format, parseISO } from 'date-fns';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Fittext, Grid, GridColumn, Heading, Notice } from 'telia-front-react';
import { useStores } from '../../stores/RootStore';
import { parseTextParams } from '../../util/TextUtil';

const RequestCallbackSuccess = observer((): React.JSX.Element => {
  const {
    callbackStore: {
      callbackCreation: { time, email }
    },
    countryCallingCodeStore: { isForeignCodeSelected }
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);
  const shouldShowSmsOrEmailSentInfo = (isForeignCodeSelected && !!email) || !isForeignCodeSelected;

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Grid>
      <GridColumn>
        <Notice type="success">
          <Heading level={4}>
            <Fittext>{translate('reservation.requestCallback.thankYou')}</Fittext>
          </Heading>
          <p>
            {parseTextParams(translate('reservation.requestCallback.date.description'), {
              date: format(parseISO(time), 'dd.MM.yyyy'),
              time: `${format(parseISO(time), 'HH.mm')}-${format(addMinutes(parseISO(time), 15), 'HH.mm')}`
            })}
          </p>
        </Notice>
        <br />
        {shouldShowSmsOrEmailSentInfo && (
          <>
            <p>{translate(`reservation.requestCallback.${isForeignCodeSelected && !!email ? 'email' : 'sms'}.description`)}</p>
            <br />
            <b>{translate(`reservation.requestCallback.cancel${isForeignCodeSelected && !!email ? '.email' : ''}.description`)}</b>
          </>
        )}
      </GridColumn>
    </Grid>
  );
});

export default RequestCallbackSuccess;
